import { createFileRoute } from '@tanstack/react-router';

import { FlexibleCalculationExportedVariablesPage } from '@/areas/flexible-calculations/FlexibleCalculationTemplates/FlexibleCalculationExportedVariablesPage';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/flexible-calculation/exported-variables')({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <FlexibleCalculationExportedVariablesPage />
        </SidebarPageContent>
    );
}
